import { useEffect, useRef } from "react"

// The console's live views refresh on one cadence.
export const liveRefreshMs = 10_000

// Calls `tick` on an interval while enabled, skipping ticks while the tab is
// hidden, so a backgrounded console stops polling.
export const useVisibleInterval = (
  tick: () => void,
  isEnabled: boolean,
  intervalMs = liveRefreshMs
) => {
  const latestTick = useRef(tick)
  latestTick.current = tick
  useEffect(() => {
    if (!isEnabled) return
    const timer = window.setInterval(() => {
      if (document.visibilityState === "visible") latestTick.current()
    }, intervalMs)
    return () => window.clearInterval(timer)
  }, [isEnabled, intervalMs])
}
